
let key_index = 0;

export default function newid(){
    return 'k'+(key_index += 1);
}